import Link from './link';
import Title from './title';

const Navigation = {
  Link, Title,
};

export default Navigation;
